"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const app_types_1 = require("pages/app.types");
const rfid_log_types_1 = require("./rfid-log.types");
const initialState = {
    errorCode: 0,
    dataGrid: [],
    dataGridExcel: [],
    isError: false,
    isLoading: false,
    errorMessage: '',
    isSuccess: false,
    mutationMode: false,
    dataDropdownPos: [],
    dataDropdownArea: [],
    dataItem: {
        id: 0,
        rfid_tag: '',
        dumptruck_no: '',
        contractor_id: '',
        dumptruck_spec: '',
        capacity_volume: 0,
        contractor_name: '',
        scan_date: new Date(new Date().setHours(0, 0, 0, 0)),
    },
    dataStates: {
        skip: 0,
        take: 10,
        total: 0,
        area: '',
        sortable: true,
        filterable: true,
        reorderable: false,
        description: '',
        checkpoint_id: '',
        end_date: new Date(new Date().setHours(0, 0, 0, 0)),
        start_date: new Date(new Date().setHours(0, 0, 0, 0)),
        checkpoint_type_id: '',
        scrollable: 'scrollable',
    }
};
const adjustmentRfidLogReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [rfid_log_types_1.adjustmentRfidLogTypes.SET_LOADING]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: action.payload.isLoading });
    },
    [rfid_log_types_1.adjustmentRfidLogTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, sort: action.payload }) });
    },
    [rfid_log_types_1.adjustmentRfidLogTypes.SET_ERROR]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, state), action.payload), { isLoading: false });
    },
    [rfid_log_types_1.adjustmentRfidLogTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [rfid_log_types_1.adjustmentRfidLogTypes.SET_DATA_GRID]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: false, dataGrid: action.payload.dataGrid, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: action.payload.countData }) });
    },
    [rfid_log_types_1.adjustmentRfidLogTypes.SET_DATA_GRID_EXPORT_EXCEL]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: false, dataGridExcel: action.payload.dataGrid, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: action.payload.countData }) });
    },
    [rfid_log_types_1.adjustmentRfidLogTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode } = action.payload;
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem });
    },
    [rfid_log_types_1.adjustmentRfidLogTypes.ON_PAGE_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: action.payload.dataStates });
    },
    [rfid_log_types_1.adjustmentRfidLogTypes.SET_DATA_DROPDOWN_AREA]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: false, dataDropdownArea: action.payload.dataDropdownArea });
    },
    [rfid_log_types_1.adjustmentRfidLogTypes.SET_DATA_DROPDOWN_POS]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: false, dataDropdownPos: action.payload.dataDropdownPos });
    }
});
exports.default = adjustmentRfidLogReducer;
